import { render, staticRenderFns } from "./ModalDlg.vue?vue&type=template&id=e50f7f22"
import script from "./ModalDlg.vue?vue&type=script&lang=ts"
export * from "./ModalDlg.vue?vue&type=script&lang=ts"
import style0 from "./ModalDlg.vue?vue&type=style&index=0&id=e50f7f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports